import { Outlet } from 'react-router-dom'

import { Box, Title } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { EnrollmentsTable } from './components/EnrollmentsTable'
import { PlanDetails } from './components/PlanDetails'
import { SummaryKPIs } from './components/SummaryKPIs'
import { useHealthcarePlanMetrics } from './hooks/useHealthcarePlanMetrics'

const HealthcareManagementPage = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const {
    selectedPlan,
    uniqueEmployees,
    dependentEnrollmentsCount,
    totalEmployees,
    totalCostCents,
    averageCostPerEmployeeCents,
    adoptionRate,
  } = useHealthcarePlanMetrics({ companyId })

  return (
    <ResponsivePage.Body>
      <Box gap="s32">
        {/* Header Section */}
        <Box gap="s8">
          <Title
            variant="400"
            title={i18n.t('benefits.healthcare.management.title')}
            description={i18n.t('benefits.healthcare.management.description')}
          />
        </Box>

        {/* Summary Metrics Section */}
        {selectedPlan && (
          <SummaryKPIs
            totalCostCents={totalCostCents}
            averageCostPerEmployeeCents={averageCostPerEmployeeCents}
            uniqueEmployees={uniqueEmployees}
            dependentEnrollmentsCount={dependentEnrollmentsCount}
            totalEmployees={totalEmployees}
            adoptionRate={adoptionRate}
          />
        )}

        {/* Plan Details Section */}
        {selectedPlan && <PlanDetails plan={selectedPlan} />}

        {/* Enrollments Data Collection */}
        <EnrollmentsTable companyId={companyId} />
      </Box>
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default HealthcareManagementPage
